import { rebottle } from "../elements";
import type { BottleType, CanvasData } from "../schema";
import { INK, centred, doc, hairline, imageSlot } from "./kit";
import type { LabelTemplate } from "./types";

// Corporate: the client's logo at the top, a line of thanks, the event below.
function wine(): CanvasData {
  const b = "wine";
  return doc(b, INK["warm-white"], [
    imageSlot({ x: 23, y: 14, width: 44, height: 18 }, "Add your logo"),
    centred(b, { text: "With our thanks", font: "cormorant", size: 4.5, color: INK.charcoal, baseline: 48, tracking: 0.02 }),
    centred(b, { text: "for your partnership in 2026", font: "cormorant", italic: true, size: 2.8, color: INK.charcoal, baseline: 55.5, tracking: 0.02 }),
    hairline(INK.bronze, 45, 61, 30),
    centred(b, { text: "Your company · Annual dinner", font: "montserrat", size: 1.8, color: INK.charcoal, baseline: 86, tracking: 0.2 }),
  ]);
}

export const corporateMark: LabelTemplate = {
  key: "corporate-mark",
  name: "Corporate",
  occasion: "corporate",
  style: "Logo and message",
  description: "Your logo, a line of thanks and the event.",
  hasImageSlot: true,
  slot: "logo",
  build: (bottle: BottleType) => (bottle === "wine" ? wine() : rebottle(wine(), bottle)),
};
